import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-469c72ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "publications py-5" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row g-4" }
const _hoisted_4 = { class: "book-card h-100 d-flex" }
const _hoisted_5 = { class: "book-image-wrapper" }
const _hoisted_6 = ["src", "onClick"]
const _hoisted_7 = { class: "book-content" }
const _hoisted_8 = { class: "book-title" }
const _hoisted_9 = { class: "book-author" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Auteur(s) :", -1))
const _hoisted_11 = { class: "book-meta" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Maison d'édition :", -1))
const _hoisted_13 = { class: "book-meta" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Année :", -1))
const _hoisted_15 = { class: "image-modal-content" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publications, (book, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-md-6 col-lg-4",
            key: i
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: book.urlImage ? _ctx.getUrlApiForFiles(book.urlImage) : _ctx.defaultPhoto,
                  alt: "Couverture du livre",
                  class: "book-image clickable",
                  onClick: ($event: any) => (_ctx.openImage(book.urlImage))
                }, null, 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h5", _hoisted_8, _toDisplayString(book.titre), 1),
                _createElementVNode("p", _hoisted_9, [
                  _hoisted_10,
                  _createTextVNode(" " + _toDisplayString(book.auteur), 1)
                ]),
                _createElementVNode("p", _hoisted_11, [
                  _hoisted_12,
                  _createTextVNode(" " + _toDisplayString(book.editeur), 1)
                ]),
                _createElementVNode("p", _hoisted_13, [
                  _hoisted_14,
                  _createTextVNode(" " + _toDisplayString(book.annepublication), 1)
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    (_ctx.showImageModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "image-modal",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeImage && _ctx.closeImage(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              class: "close-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeImage && _ctx.closeImage(...args)))
            }, "×"),
            _createElementVNode("img", {
              src: _ctx.activeImage,
              alt: "Image agrandie",
              class: "image-modal-img"
            }, null, 8, _hoisted_16)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_PaginationComponent, {
        page: _ctx.page,
        totalPages: _ctx.totalPages,
        totalElements: _ctx.totalElements,
        limit: _ctx.limit,
        onPaginate: _ctx.handlePaginate
      }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
    ])
  ]))
}